import { Badge, Button, Col, Row, Space, Table, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { Link, RouteChildrenProps, useHistory } from "react-router-dom";
import { FilterModuleEnum, ReportStatesEnum, ReportStatusEnum, ReportTypeEnum, SourceModuleEnum } from "../../../../constants/constants";
import { ROUTE_PATHS } from "../../../../constants/url-config";
import { ReportModel } from "../../../../models/report.model";
import { ScenarioFrontierModel } from "../../../../models/scenario-frontier.model";
import { ECAPService } from "../../../../services/ecap.service";
import { ScenarioFrontierService } from "../../../../services/scenario-frontier.service";
import { DATE_UTIL } from "../../../../utils/dateUtils";
import i18n from "../../../../utils/i18n";
import UTIL from "../../../../utils/utils";
import { ArrowRightLink } from "../../../atoms/icon";
import { quarters } from "../select-period";
import "./approval-workfow.scss";

const { TabPane } = Tabs;

enum TabKeyEnum {
    All = "1",
    AssetQuality = "2",
    CreditConcentration = "3",
    IFRSCECL = "4",
    ScenarioBudgeting = "5",
    ResilienceDashboard = "6"
}


interface Props extends RouteChildrenProps { }

const ScenarioFrontierApprovalWorkflow = (props: Props) => {

    const [status, setStatus] = useState<ReportStatesEnum>(ReportStatesEnum.Submitted);
    const [data, setData] = useState<any[]>([]);
    const [displayData, setDisplayData] = useState<any[]>([]);
    const [ermData, setErmData] = useState<any[]>([]);
    const [isLoading, setLoading] = useState(0);
    const [activatedModule, setActivatedModule] = useState<TabKeyEnum>(TabKeyEnum.All);
    const [title, setTitle] = useState("Inbox");
    const history = useHistory();

    const tabs = [{
        key: TabKeyEnum.All,
        name: i18n.t("Global.lbAll")
    },
    {
        key: TabKeyEnum.ScenarioBudgeting,
        name: i18n.t("ScenarioFrontier.lbScenarioAndBudgeting")
    },
    {
        key: TabKeyEnum.CreditConcentration,
        name: i18n.t("ScenarioFrontier.lbCreditandConcentration")
    },
    {
        key: TabKeyEnum.IFRSCECL,
        name: i18n.t("ScenarioFrontier.lbIFRSCECL")
    },
    {
        key: TabKeyEnum.AssetQuality,
        name: i18n.t("ScenarioFrontier.lbAssetQuality")
    }, {
        key: TabKeyEnum.ResilienceDashboard,
        name: i18n.t("ScenarioFrontier.lbResilienceDashboard")
    }]

    const getSourceName = (module: string) => {
        switch (module) {
            case SourceModuleEnum.LossEvent:
                return "ERM - Control Failure";
            case SourceModuleEnum.LossScenario:
                return "ERM - Scenarios Assessment";
            default:
                return i18n.t("ScenarioFrontier.lbScenarioAndBudgeting");;
        }
    }

    const checkShowMitigationAndAppraisal = (obj?: { id?: number; submit_state?: ReportStatesEnum }) => {
        return obj && (obj.submit_state === ReportStatesEnum.Submitted || obj.submit_state === ReportStatesEnum.Approved);
    }

    const columns = [
        {
            title: "Report Name",
            dataIndex: 'report_name',
            key: 'report_name',
            render: (text: string, record: any) => {

                let url = `${ROUTE_PATHS.ScenarioFrontierReviewReport}/${record.id}`;
                if (record.source === SourceModuleEnum.LossScenario) {
                    url = `${ROUTE_PATHS.ApprovalWorkflowScenario}/${record.id}`
                } else if (record.source === SourceModuleEnum.LossEvent) {
                    url = `${ROUTE_PATHS.ApprovalWorkflowControlFalure}/${record.id}`
                }

                return (
                    <div className="row-link-wrapper">
                        {
                            record.source === SourceModuleEnum.LossScenario &&
                            (checkShowMitigationAndAppraisal(record.scenario_mitigation) || checkShowMitigationAndAppraisal(record.appraisal_tool)) && <ArrowRightLink />
                        }

                        <div className="row-link">
                            <Link className="blue-text" to={url}>
                                {!!record.source ? text : `Scenario Report - ${record.fiscalYear} - ${quarters.find(x => x.value === record.quarter)?.text}`}</Link>
                            {
                                checkShowMitigationAndAppraisal(record.scenario_mitigation) &&
                                <Link className="related-action" to={`${ROUTE_PATHS.ApprovalWorkflowMitigation}/${record.id}`}>Mitigation Form</Link>
                            }

                            {
                                checkShowMitigationAndAppraisal(record.appraisal_tool) && <Link className="related-action" to={`${ROUTE_PATHS.ApprovalWorkflowAppraisal}/${record.id}`} >Project Appraisal Form</Link>
                            }
                        </div>

                    </div>
                )

            }
        },
        {
            title: "Author",
            dataIndex: 'created_by',
            key: 'created_by',
        },
        {
            title: "Source",
            dataIndex: 'source',
            key: 'source',
            render: (text: string) => getSourceName(text)
        },
        {
            title: "Status",
            dataIndex: 'submit_state',
            key: 'submit_state',
            render: (text: string) => {
                const dom = UTIL.getLossStatesDOM(text);
                return (<span style={{ color: dom.color }}>
                    {dom.text}
                </span>)
            }
        },
        {
            title: "Submission Date",
            dataIndex: 'submittedOn',
            key: 'submittedOn',
            render: (date: string) => date ? DATE_UTIL.convertServerToViewFormat(date) : <div>-</div>
        },
        {
            title: "Decision Date",
            dataIndex: 'decision_date',
            key: 'decision_date',
            render: (date: string) => date ? DATE_UTIL.convertServerToViewFormat(date) : <div>-</div>
        }
    ];

    const statusChange = (stt: ReportStatesEnum) => {
        switch (stt) {
            case ReportStatesEnum.Submitted:
                setTitle(i18n.t("Global.lbNeedReview"));
                break;
            case ReportStatesEnum.Approved:
                setTitle(i18n.t("Global.lbApproved"));
                break;
            case ReportStatesEnum.Rejected:
                setTitle(i18n.t("Global.lbReturned"));
                break;
            default:
                break;
        }

        if (stt === status) {
            return;
        }

        setStatus(stt);
    }

    const getData = () => {
        setData([]);
        setLoading(pre => pre + 1);
        ScenarioFrontierService.getApprovalReports(status).then(res => {
            setData(res.data);
        }).finally(() => {
            setLoading(pre => pre - 1);
        })

        setLoading(pre => pre + 1);
        setData([]);


        let stt: ReportStatusEnum = ReportStatusEnum.Pending;

        switch (status) {
            case ReportStatesEnum.Submitted:
                stt = ReportStatusEnum.Pending;
                break;
            case ReportStatesEnum.Approved:
                stt = ReportStatusEnum.Approved;
                break;
            case ReportStatesEnum.Rejected:
                stt = ReportStatusEnum.Referred;
                break;
            default:
                break;
        }

        ECAPService.getReportAsyns(stt, FilterModuleEnum.ERM).then(res => {
            setErmData(res.data);
        }).finally(() => setLoading(pre => pre - 1));

    }

    const getReportCount = (key: TabKeyEnum) => {
        switch (key) {
            case TabKeyEnum.All:
                return data?.length + ermData?.length;
            case TabKeyEnum.ScenarioBudgeting:
                return data?.length || 0;
            case TabKeyEnum.ResilienceDashboard:
                return ermData?.length || 0;
            default:
                return 0;
        }
    }

    const updateDispayData = () => {
        switch (activatedModule) {
            case TabKeyEnum.All:
                setDisplayData(data.concat(ermData));
                break;
            case TabKeyEnum.ScenarioBudgeting:
                setDisplayData(data);
                break;
            case TabKeyEnum.ResilienceDashboard:
                setDisplayData(ermData);
                break;
            default:
                setDisplayData([]);
                break;
        }
    }

    useEffect(() => {
        updateDispayData();
    }, [activatedModule, data, ermData])

    useEffect(() => {
        getData();
    }, [status])

    return (
        <div className="approval-workflow-wrapper">
            <Row>
                <Col span={24}>
                    <Space>
                        <Button type={status === ReportStatesEnum.Submitted ? "primary" : "default"} shape="round" onClick={() => statusChange(ReportStatesEnum.Submitted)}>
                            {i18n.t("Global.lbInbox")}
                        </Button>
                        <Button type={status === ReportStatesEnum.Approved ? "primary" : "default"} shape="round" onClick={() => statusChange(ReportStatesEnum.Approved)}>
                            {i18n.t("Global.lbApproved")}
                        </Button>
                        <Button type={status === ReportStatesEnum.Rejected ? "primary" : "default"} shape="round" onClick={() => statusChange(ReportStatesEnum.Rejected)}>
                            {i18n.t("Global.lbReturned")}
                        </Button>
                    </Space>
                </Col>
            </Row>

            <Tabs defaultActiveKey={TabKeyEnum.All} onChange={activeKey => { setActivatedModule(activeKey as TabKeyEnum) }}>
                {tabs.map((item) =>
                    <TabPane
                        tab={<>{item.name} <Badge count={getReportCount(item.key)} showZero overflowCount={999}>
                        </Badge></>}
                        key={item.key}>
                    </TabPane>)}
            </Tabs>

            <Row>
                <Col sm={18}>
                    <h4>
                        {title}
                    </h4>
                </Col>
                <Col sm={6} className='action-box'>
                    {/* <div className='search'>
                        <SearchBox searchEvent={search} placeholder={"Search anything"} />
                    </div> */}
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Table
                        // onRow={(record, rowIndex) => ({ onClick: event => { rowClick(record) } })}
                        dataSource={displayData}
                        columns={columns}
                        loading={!!isLoading}
                        rowKey={(record) => `${record.id}${record.source}`} />
                </Col>
            </Row>
        </div>
    )
}

export default ScenarioFrontierApprovalWorkflow;